<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{formTitle}}</span>
      </v-card-title>
      <v-card-text>
        <v-flex xs12 sm6 md6>
          <v-text-field
            type="nombre"
            v-model="object.nombre"
            label="Nombre"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field
            type="apellido"
            v-model="object.apellido"
            label="Apellido"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field
            type="email"
            v-model="object.email"
            label="Email"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field
            type="password"
            v-model="object.contrasena"
            label="Contraseña"
          ></v-text-field>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="object" color="blue darken-1" text @click="close">
          Volver
        </v-btn>
        <v-btn v-else color="blue darken-1" text @click="close">
          Cancelar
        </v-btn>
        <v-btn color="blue darken-1" text @click="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
    };
  },
  props: {
    object: Object,
    show: Boolean,
    update: Boolean,
  },
  created() {
    moment.locale("ES");
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario", "usuarios"]),
    formTitle() {
      return this.update ? "Edución de registro" : "Nuevo Registro";
    }
  },
  methods: {
    guardar() {
      this.$emit("save", this.object);
      this.clear();
    },
    close() {
      this.$emit("close");
      this.clear();
    },
    clear() {
      this.object = {};
    },
  },
};
</script>

<style></style>
